import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import sunriseIcon from "../../icons/icon-sunrise.svg"
import sunsetIcon from "../../icons/icon-sunset.svg"
import Timestamp from "../../ui/Timestamp"
import { useSelector } from "react-redux"
import { selectAdvancedMode } from "../settings/slice"

const Label = styled.div`
  flex: auto;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
`

const Container = styled.div`
  display: flex;
  align-items: stretch;
  padding: 0.5rem;
`

const ImageIcon = styled.div`
  flex: none;
  width: 3rem;
  min-height: 3rem;
  background-position: center 40%;
  background-size: 2.75rem;
  background-repeat: no-repeat;
`

const SunriseIcon = styled(ImageIcon)`
  background-image: url(${sunriseIcon});
`
const SunsetIcon = styled(ImageIcon)`
  background-image: url(${sunsetIcon});
`

const Classifier = styled.div`
  padding-right: 0.5rem;
`

const SunInfo = ({ sunrise_utc, sunset_utc }) => {
  // User setting to show more details such as id's
  const advancedMode = useSelector(selectAdvancedMode)

  return (
    <>
      {sunrise_utc && (
        <Container>
          <SunriseIcon />
          <Label>
            <Classifier>Nautical sunrise</Classifier>
            <Timestamp utc={advancedMode} date={false}>
              {sunrise_utc}
            </Timestamp>
          </Label>
        </Container>
      )}
      {sunset_utc && (
        <Container>
          <SunsetIcon />
          <Label>
            <Classifier>Nautical sunset</Classifier>
            <Timestamp utc={advancedMode} date={false}>
              {sunset_utc}
            </Timestamp>
          </Label>
        </Container>
      )}
    </>
  )
}

SunInfo.propTypes = {
  sunrise_utc: PropTypes.string, // as SQL datetime e.g.2022-10-17 19:56:06.614616+00:00
  sunset_utc: PropTypes.string, // as SQL datetime  e.g.2022-10-17 19:56:06.614616+00:00
  dawn_utc: PropTypes.string, // as SQL datetime  e.g.2022-10-17 19:56:06.614616+00:00
  dusk_utc: PropTypes.string, // as SQL datetime  e.g.2022-10-17 19:56:06.614616+00:00
}

export default SunInfo
